import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../../src/lib/supabase';
import { classificarMinhasTarefas, type MinhasTarefas, type TarefaAberta } from '../../src/lib/visaoGeral/minhasTarefas';
import { isoLocal } from '../../src/lib/visaoGeral/periodo';

/**
 * Atividades do CRM e solicitações da Central abertas no nome da pessoa.
 * Busca só o que é dela e só as colunas usadas: a Visão Geral antiga baixava as
 * ~6 mil tarefas do sistema a cada abertura.
 */
export function useMinhasTarefas(pessoaId: string | null | undefined) {
  const [dados, setDados] = useState<MinhasTarefas | null>(null);
  const [erro, setErro] = useState<string | null>(null);

  const carregar = useCallback(async () => {
    if (!pessoaId) return;
    setErro(null);
    const { data, error } = await supabase
      .from('tarefas')
      .select('id, titulo, vencimento, status, categoria, solicitacao_status, prioridade, negociacao_id')
      .eq('responsavel_id', pessoaId)
      .not('status', 'in', '(concluido,cancelado)')
      .order('vencimento', { ascending: true, nullsFirst: false })
      .limit(1000);
    if (error) {
      setErro(error.message);
      setDados(classificarMinhasTarefas([], isoLocal(new Date())));
      return;
    }
    setDados(classificarMinhasTarefas((data || []) as TarefaAberta[], isoLocal(new Date())));
  }, [pessoaId]);

  useEffect(() => {
    setDados(null);
    carregar();
  }, [carregar]);

  return { dados, erro, recarregar: carregar };
}
